<mat-form-field
  appearance="outline"
  [ngClass]="{ 'mat-form-field-readonly': readonly }"
>
  <mat-label [ngClass]="{ 'label-text-readonly': readonly }">{{
    "nation" | translate
  }}</mat-label>
  <mat-select [formControl]="control">
    <mat-select-trigger>
      {{ control.value?.name || "- -" }}
    </mat-select-trigger>

    <mat-option [value]="null">- -</mat-option>
    <mat-option
      *ngFor="let country of COUNTRIES"
      [value]="country"
    >
      {{ country.name }}
    </mat-option>
  </mat-select>

  <mat-error *ngIf="control.invalid && control.touched && required">
    {{ "country.required" | translate }}
  </mat-error>
</mat-form-field>
